export enum InjectedTypes {
  Any = "Any",
  Ad = "Ad",
  Native = "Native",
  House = "House",
  Recirc = "Recirc",
  Books = "Books",
  MagPromo = "MagPromo",
}

export enum ArticleElementTypes {
  Begin = "Begin",
  Heading = "Heading",
  Figure = "Figure",
  Quote = "Quote",
  End = "End",
  List = "List",
  HorizRule = "HorizRule",
  BracketedLink = "BracketedLink",
  LegacyHtml = "LegacyHtml",
  AdPlaceholder = "AdPlaceholder",
  RecircPlaceholder = "RecircPlaceholder",
  Dropcap = "Dropcap",
  Salutations = "Salutations",
}

export interface Rule {
  item: InjectedTypes;
  from: InjectedTypes | ArticleElementTypes;
  index?: number;
  indexNotEqual?: number;
  after?: string;
  before?: string;
}

export interface RuleInPixels {
  item: InjectedTypes;
  from: InjectedTypes | ArticleElementTypes;
  index?: number;
  indexNotEqual?: number;
  after?: number;
  before?: number;
}

export interface ElementPosition {
  /** the top y position */
  top: number;
  /** the bottom y position */
  bottom: number;
  /** the top y position including the top margin */
  topMargin: number;
  /** the bottom y position including the bottom margin */
  bottomMargin: number;
}

export interface OverlapBlock {
  /** the start index of the block of overlapping elements */
  start: number;
  /** the end index of the block of overlapping elements */
  end: number;
}

export interface InjectedComponent {
  type: InjectedTypes;
  afterIndex: number;
}

export interface InjectorOrderOptions {
  /** If we should inject a Recirc module */
  injectRecirc: boolean;
  /** If we should inject a Books Module. */
  injectBooksModule: boolean;
  /** If we should inject a Magazine Promo. */
  injectMagPromo: boolean;
  /** If we should inject ads  */
  injectAds: boolean;
}

export interface InjectorOptions {
  /** Test variant string */
  activeTestGroup: string | null;
  /** If the browser is mobile */
  isMobile: boolean;
  /** If the recirc module is displayed at full width */
  isRecircFullwidth: boolean;
  /** If the books module is displayed at full width */
  isBooksFullwidth: boolean;
  /** Options for changing what is injected into the order */
  injectOrderOptions: InjectorOrderOptions;
  /** The id of the article */
  articleId: string;
}

export interface InjectorOverrides {
  /** an optional override of injection rules. For testing */
  injectionRules?: Rule[];
  /** an optional override of items to inject. For testing */
  injectionOrder?: InjectedTypes[];
}
